/**
 * Hook para tema (light, dark, system).
 * Estado em `themeStore` (ThemeLoader hidrata após login).
 */

import { useThemeStore } from '@/shared/lib/themeStore'

export type { ThemeMode, ResolvedTheme } from './themeUtils'

export const useTheme = () => {
  const mode = useThemeStore((s) => s.mode)
  const resolved = useThemeStore((s) => s.resolved)
  const ready = useThemeStore((s) => s.ready)
  const setMode = useThemeStore((s) => s.setMode)
  return { mode, resolved, setMode, ready }
}
